import { AvIssueIcon } from "components/av/av_issue_icon";

function IconMenu() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
        fill="white"
      />
      <path
        d="M2 10C3.10457 10 4 9.10457 4 8C4 6.89543 3.10457 6 2 6C0.89543 6 0 6.89543 0 8C0 9.10457 0.89543 10 2 10Z"
        fill="white"
      />
      <path
        d="M14 10C15.1046 10 16 9.10457 16 8C16 6.89543 15.1046 6 14 6C12.8954 6 12 6.89543 12 8C12 9.10457 12.8954 10 14 10Z"
        fill="white"
      />
    </svg>
  );
}

function ParticipantInfoMenuIcon({
  avIssue,
  micError,
  cameraError,
  poorConnection,
}: {
  avIssue: boolean;
  micError: boolean;
  cameraError: boolean;
  poorConnection: boolean;
}) {
  return avIssue && micError ? (
    <AvIssueIcon
      title="This user has an issue with their microphone."
      style={{ paddingBottom: "4px" }}
    />
  ) : avIssue ? (
    <AvIssueIcon title="This user's A/V is not available." style={{ paddingBottom: "4px" }} />
  ) : poorConnection ? (
    <AvIssueIcon
      poorConnection
      title="This user has a poor connection."
      style={{ paddingBottom: "4px" }}
    />
  ) : cameraError ? (
    <AvIssueIcon
      title="This user has an issue with their camera."
      style={{ paddingBottom: "4px" }}
    />
  ) : (
    <IconMenu />
  );
}

export { IconMenu, ParticipantInfoMenuIcon };
